module.exports = __webpack_public_path__ + "static/media/pro3.2132c485.png";